import {useNavigate} from "react-router-dom";
import _axios from "../../httpService";
import {prefixUrl} from "../../utils/utilsData";
import {toast} from "react-toastify";


const AddKpiButton = ({id, tableConfig}) => {
  const navigateTo = useNavigate();

  return <button
    className="btn btnFixedOverWrite"
    onClick={() => {
      navigateTo("/FormKpiBuilder", {
        state: {
          value: {
            id: id,
            hasKpiId: tableConfig.hasKpi,
            kpiOptions: tableConfig.kpiOptions,
          }
        }
      })
    }}
  >
    <i className="fa fa-edit"></i> افزودن KPI
  </button>
}
const KpiButtons = ({data}) => {
  const navigateTo = useNavigate();
  return data.allKpi.kpi.map((value, index) => (
    <button
      key={index}
      className="btn btnFixedOverWrite"
      onClick={() => {
        navigateTo("/openKpiPage", {
          state: {value: value},
        });
      }}
    >
      {value.title}
    </button>
  ))
}
const BarcodePrintInTable = ({SendTabulatorFilteredData}) => {


  return <button
    className="btn btnFixedOverWrite"
    onClick={SendTabulatorFilteredData}>
    <i className="fa fa-plus"></i> پرینت بارکد
  </button>
}

const AddNew = ({onClick}) => <button
  className="btn btnFixedOverWrite"
  onClick={onClick}
>
  <i className="fa fa-plus"></i> افزودن
</button>

const DeleteButton = ({removeRowHandler}) => <button
  className="btn btnFixedOverWrite"
  onClick={removeRowHandler}
>
  <i className="fa fa-trash"></i> حذف
</button>


const PrintTable = ({printTableHandler}) => <button
  className="print-btn btn btnFixedOverWrite"
  onClick={printTableHandler}
>
  <i className="fas fa-print mr-2"></i>پرینت
</button>


const ExcelExport = ({exportExcelHandler}) => <button
  className="print-btn btn btnFixedOverWrite"
  onClick={exportExcelHandler}
>
  <i className="fas fa-print mr-2"></i>دانلود اکسل
</button>

const EditRowInTable = ({editHandler, selectedRow}) => <button
  className="btn btnFixedOverWrite"
  onClick={editHandler}
  disabled={selectedRow === undefined}
>
  <i className="fa fa-edit"></i> ویرایش
</button>

const EditRowInTable2 = ({editHandler2, selectedRow}) => <button
  className="btn btnFixedOverWrite"
  // onClick={()=>navigate("/Operation/2-m")}
  onClick={editHandler2}
  disabled={selectedRow === undefined}
>
  <i className="fa fa-edit"></i> ویرایش
</button>


const FollowUpSystem = ({onClickFollowUpSystem, selectedRow}) => <button
  className="btn btnFixedOverWrite"
  onClick={onClickFollowUpSystem}
  disabled={selectedRow === undefined}
>
  <i className="fa fa-edit"></i> درج پیگیری
</button>

const FollowUpList = ({selectedRow, listName}) => {
  const navigateTo = useNavigate();

  return (
    <button
      className="btn btnFixedOverWrite"
      onClick={() => navigateTo("/FollowUpList",
        {state: {pkValue: selectedRow.getData()['primaryKey'], listName: listName}})}
      disabled={selectedRow === undefined}
    >
      <i className="fa fa-edit"></i> پرونده پیگیری ها
    </button>
  )
}
const GoToDocumentForm = ({selectedRow, listName}) => {
  const navigateTo = useNavigate();

  const clickHandler = () => {
    console.log(selectedRow)

    const pkValue = selectedRow.getData().primaryKey;
    const url = `/accountingDocument/?request=getDocumentId&entity=${listName}&pkValue=${pkValue}`
    _axios.get(prefixUrl() + url).then(res => {

      if (res.data.status) {

        navigateTo("/coding/submitDocumentForm", {
          state: {
            manualDocumentId:res.data.id ,id:res.data.id ,
            from: { url: "backUrl", data: {} },
          },
        });
      } else {
        toast.error(res.data.message)
      }
    })
  }
  return (
    <button
      className="btn btnFixedOverWrite"
      onClick={clickHandler}
      disabled={selectedRow === undefined}
    >
      <i className="fa fa-edit"></i> سند اتوماتیک
    </button>
  )
}

const ConfirmOrder = ({onClick, selectedRow}) => <button
  className="btn btnFixedOverWrite"
  onClick={onClick}
  disabled={selectedRow === undefined}
>
  <i className="fa fa-check"></i> تایید سفارش
</button>

const OrderDetails = ({onClick, selectedRow}) => <button
  className="btn btnFixedOverWrite"
  onClick={onClick}
  disabled={selectedRow === undefined}
>
  <i className="fa fa-info-circle"></i> جزئیات سفارش
</button>

const ArchiveButton = ({onClick, selectedRow}) => <button
  className="btn btnFixedOverWrite"
  onClick={onClick}
  disabled={selectedRow === undefined}
>
  <i className="fa fa-archive"></i> بایگانی
</button>

const UnarchiveButton = ({onClick, selectedRow}) => <button
  className="btn btnFixedOverWrite btn-warning"
  onClick={onClick}
  disabled={selectedRow === undefined}
>
  <i className="fa fa-undo"></i> خروج از بایگانی
</button>

const ShowArchivedToggle = ({showArchived, onClick}) => <button
  className={`btn ${showArchived ? 'btn-secondary' : 'btnFixedOverWrite'}`}
  onClick={onClick}
>
  <i className={`fa ${showArchived ? 'fa-eye-slash' : 'fa-archive'}`}></i>
  {showArchived ? ' نمایش فعال‌ها' : ' نمایش بایگانی‌ها'}
</button>

const TableButtons = {
  AddKpiButton,
  KpiButtons,
  BarcodePrintInTable,
  AddNew,
  DeleteButton,
  PrintTable,
  ExcelExport,
  EditRowInTable,
  EditRowInTable2,
  FollowUpSystem,
  FollowUpList,
  GoToDocumentForm,
  ConfirmOrder,
  OrderDetails,
  ArchiveButton,
  UnarchiveButton,
  ShowArchivedToggle,
}


export default TableButtons;